import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is m/s2
export const Acceleration: BaseQuantity = {
  id: "001acceleration",
  name: "acceleration",
  type: "numeric",
  value: "",
  symbol: "a",
  baseUnit: "m/s\u00b2",
  selectedUnit: "m/s\u00b2",
  units: [{ name: "m/s\u00b2", fromConst: 1, toConst: 1 }],
};
